###
# Module: data/labels.coffee
# Summary: Label metadata powering badge styling in the license list.
###
LabelsDefinitions =
  public:
    text: 'Publicly Available'
    title: 'Under this license your resource will be publicly available'
    itemClass: 'ls-label-public'
  aca:
    text: 'Academic Use'
    title: 'License restricts the use only for research and educational purposes'
    itemClass: 'ls-label-aca'
  res:
    text: 'Restricted Use'
    title: 'License further restricts the use'
    itemClass: 'ls-label-res'
  pd:
    title: 'Public Domain Mark'
    itemClass: 'ls-icon-pd'
  cc:
    title: 'Creative Commons'
    itemClass: 'ls-icon-cc'
  zero:
    title: 'Creative Commons Zero'
    itemClass: 'ls-icon-zero'
  by:
    title: 'Attribution Required'
    itemClass: 'ls-icon-by'
  sa:
    title: 'Share-alike'
    itemClass: 'ls-icon-sa'
  nd:
    title: 'No Derivative Works'
    itemClass: 'ls-icon-nd'
  nc:
    title: 'Noncommercial'
    itemClass: 'ls-icon-nc'
  perl:
    title: 'Recommended for Perl software'
    itemClass: 'ls-icon-perl'
  osi:
    title: 'Approved by Open Source Initiative'
    itemClass: 'ls-icon-osi'
  gpl:
    title: 'General Public License'
    itemClass: 'ls-icon-gpl'
  gpl3:
    title: 'Latest General Public License version 3.0'
    itemClass: 'ls-icon-gpl3'
  agpl3:
    title: 'Latest Affero General Public License version 3.0'
    itemClass: 'ls-icon-agpl3'
  lgpl:
    title: 'Library General Public License'
    itemClass: 'ls-icon-lgpl'
  lgpl3:
    title: 'Latest Library General Public License version 3.0'
    itemClass: 'ls-icon-lgpl3'
  copyleft:
    title: 'Copyleft'
    itemClass: 'ls-icon-copyleft'
  mozilla:
    title: 'License endorsed by Mozilla Foundation'
    itemClass: 'ls-icon-mozilla'
  mit:
    title: 'MIT License'
    itemClass: 'ls-icon-mit'
  bsd:
    title: 'BSD License'
    itemClass: 'ls-icon-bsd'
  apache:
    title: 'License endorsed by Apache Foundation'
    itemClass: 'ls-icon-apache'
  eclipse:
    title: 'License endorsed by Eclipse Foundation'
    itemClass: 'ls-icon-eclipse'
  opendata:
    title: 'Open Data'
    itemClass: 'ls-icon-opendata'

module.exports = LabelsDefinitions
